var map = {
	"./cer1.png": [
		96,
		3
	],
	"./cer2.png": [
		97,
		4
	],
	"./cer3.png": [
		98,
		5
	],
	"./cer4.png": [
		99,
		6
	],
	"./cer5.png": [
		100,
		7
	],
	"./hero.png": [
		28
	],
	"./methodology.png": [
		29
	],
	"./news.png": [
		30
	],
	"./partner1.png": [
		101,
		8
	],
	"./partner2.png": [
		102,
		9
	],
	"./partner3.png": [
		103,
		10
	],
	"./partner4.png": [
		104,
		11
	],
	"./partner5.png": [
		105,
		12
	],
	"./wns.png": [
		106,
		13
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 86;
module.exports = webpackAsyncContext;